import styled from 'styled-components';

export const AccordionSection = styled.div`
  border: ${({ theme }) => `1px ${theme.colors.platinum} solid`};
  border-radius: ${({ theme }) => theme.radius.s};
  display: flex;
  flex-direction: column;
`;

export const AccordionContent = styled.div`
  border-bottom: ${({ theme }) => `1px ${theme.colors.platinum} solid`};
`;

export const AccordionTitleContent = styled.a`
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.dimGray};
  margin: ${({ theme }) => `${theme.spacing.m} 0`};
  display: block;
`;

export const MainTabs = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const MediumDiv = styled.div`
  width: ${({ theme }) => theme.width.half};
`;
